import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';

import { AuthService } from '../../../core/auth/auth.service';
import { hasMinRole } from '../../../core/auth/role.model';

import { SiteService } from '../../../core/services/site.service';
import { SiteSensorManageComponent } from '../site-sensor-manage/site-sensor-manage';
import { SiteDrawingManageComponent } from '../site-drawing-manage/site-drawing-manage';
import { SiteDashboardComponent } from '../../../shared/components/site-dashboard/site-dashboard';

@Component({
  selector: 'app-site-detail',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    SiteSensorManageComponent,
    SiteDrawingManageComponent,
    SiteDashboardComponent
  ],
  templateUrl: './site-detail.html',
  styleUrl: './site-detail.scss',
})
export class SiteDetailComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private siteService = inject(SiteService);

  public id = input<string | undefined>(undefined);

  /** dep_admin以上のロールのみ戻るボタンを表示 */
  public canGoBack = computed(() => hasMinRole(this.authService.userRole(), 'dep_admin'));

  public siteDetail = computed(() => {
    const siteId = this.id();
    if (siteId) {
      return this.siteService.getSiteDetail(siteId);
    }
    const list = this.siteService.siteListItems();
    if (list.length > 0) {
      return this.siteService.getSiteDetail(list[0].id);
    }
    return undefined;
  });

  public goBack(): void {
    this.router.navigate(['/sites/list']);
  }
}
